import { render, staticRenderFns } from "./LicenceItem.vue?vue&type=template&id=5aeee0f6&scoped=true&"
import script from "./LicenceItem.vue?vue&type=script&lang=js&"
export * from "./LicenceItem.vue?vue&type=script&lang=js&"
import style0 from "./LicenceItem.vue?vue&type=style&index=0&id=5aeee0f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aeee0f6",
  null
  
)

export default component.exports